import React from "react";
import { FieldProps } from "formik";
import xor from "lodash/xor";

type TCheckOption = {
  value: string;
  label: string;
};

interface CheckboxGroupProps extends FieldProps {
  label?: string;
  options: TCheckOption[];
}

export default ({ label, options = [], field, form }: CheckboxGroupProps) => {
  return (
    <div className="form-group">
      {label && <label className="control-label">{label}</label>}

      {options.map(({ value, label }, key) => (
        <div key={key} className="ml-2">
          <div
            style={{ display: "inline-block" }}
            className="custom-control custom-checkbox"
            onClick={() => form.setFieldValue(field.name, xor(field.value, [value]))}>
            <input type="checkbox" className="custom-control-input" checked={(field.value || []).includes(value)} onChange={() => {}} />
            <label className="custom-control-label">{label}</label>
          </div>
        </div>
      ))}
    </div>
  );
};
